import { type OrderHeaderFieldErrors } from '../types/OrderHeaderFieldErrors'

export class OrderValidationError extends Error {
  constructor(public readonly fieldErrors: OrderHeaderFieldErrors) {
    super(Object.values(fieldErrors)[0]?.message ?? 'Order field errors')
    this.name = 'OrderValidationError'
  }
}
